import EventsFallback from '../../../../lib/events_fallback';

namespace('IO.Views.Components.Rje.Api', function (exports) {
  exports.StateActions = class StateActions extends EventsFallback {
    constructor(...args) {
      super(...args);
      this.csrf = options.csrf;
    }

    start(url) {
      var req = this._makePutRequest(url);

      req.done(_.bind(this._startDoneCallback, this));
      req.fail(_.bind(this._startFailCallback, this));
    }

    _startDoneCallback(resp) {
      if (resp.statuscode === 0) {
        this.trigger('start:success', resp);
      } else {
        this._startFailCallback(resp);
      }
    }

    _startFailCallback(resp) {
      if (arguments.length === 1) {
        this.trigger('start:fail', resp);
      } else {
        this.trigger('start:fail', {});
      }
    }

    stop(url) {
      var req = this._makePutRequest(url);

      req.done(_.bind(this._stopDoneCallback, this));
      req.fail(_.bind(this._stopFailCallback, this));
    }

    _stopDoneCallback(resp) {
      if (resp.statuscode === 0) {
        this.trigger('stop:success', resp);
      } else {
        this._stopFailCallback(resp);
      }
    }

    _stopFailCallback(resp) {
      if (arguments.length === 1) {
        this.trigger('stop:fail', resp);
      } else {
        this.trigger('stop:fail', {});
      }
    }

    restart(url) {
      var req = this._makePutRequest(url);

      req.done(_.bind(this._restartDoneCallback, this));
      req.fail(_.bind(this._restartFailCallback, this));
    }

    _restartDoneCallback(resp) {
      if (resp.statuscode === 0) {
        this.trigger('restart:success', resp);
      } else {
        this._restartFailCallback(resp);
      }
    }

    _restartFailCallback(resp) {
      if (arguments.length === 1) {
        this.trigger('restart:fail', resp);
      } else {
        this.trigger('restart:fail', {});
      }
    }

    halt(url) {
      var req = this._makePutRequest(url);

      req.done(_.bind(this._haltDoneCallback, this));
      req.fail(_.bind(this._haltFailCallback, this));
    }

    _haltDoneCallback(resp) {
      if (resp.statuscode === 0) {
        this.trigger('halt:success', resp);
      } else {
        this._haltFailCallback(resp);
      }
    }

    _haltFailCallback(resp) {
      if (arguments.length === 1) {
        this.trigger('halt:fail', resp);
      } else {
        this.trigger('halt:fail', {});
      }
    }

    _makePutRequest(url) {
      return $.ajax({
        type: 'post',
        url: url,
        data: {
          _method: 'put',
          authenticity_token: this.csrf,
        },
      });
    }

    _makeGetRequest(url) {
      return $.ajax({
        url: url,
      });
    }
  };
});
